function TempReservationReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">TempReservationReport</div>
      </>
    );
  }
  
  export default TempReservationReport;